import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import _get from 'lodash.get';
import s from './MatchCenterCard.scss';
import CricketRanking from '../CricketRanking/CricketRanking';
import Timeline from '../../../../liveblog_v2/components/common/Timeline/Timeline';
import CricketScorecardV2 from '../../../../../components_v2/common/CricketScoreCardV2';
import CoverLayout from '../../../../home/components/mobile/CoverLayout';
import makeRequest from '../../../../../utils/makeRequest';
import MatchSquadList from '../MatchSquadList/MatchSquadList';
import MatchStatsList from '../MatchStatsList/MatchStatsList';
import {
  commentaryTab,
  ScoreCardTab,
  ArticleNewsTab,
  processBatsMan,
  processBowler,
  processPredictorData,
  processCommentaryData,
  processFallOfWickets,
} from './MatchCenterCardUtils';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import StatList from '../../../../../components_v2/common/StatList/StatList';
import MatchCenterLiveCard from '../MatchCenterLiveCard/MatchCenterLiveCard';
//import { Link } from '@material-ui/core';

//import { Link } from '@material-ui/core';

const MatchCenterCard = props => {
  const inningsMappings = ['1st', '2nd', '3rd', '4th'];
  let groupData = [
    ScoreCardTab,
    {
      link: 'matchDetailsData',
      name: 'Match Details',
      slug: 'match-center-details',
      is_active: 'true',
      id: 'matchDetailsDataContainer',
    },
    {
      link: 'matchStatsData',
      name: 'Teams Matchup',
      slug: 'match-center-stats',
      is_active: 'true',
      id: 'matchStatsDataContainer',
    },
    {
      link: 'matchSquadData',
      name: 'Squads',
      slug: 'match-center-squads',
      is_active: 'false',
      id: 'matchSquadDataContainer',
    },
    ArticleNewsTab,
    commentaryTab,
  ];
  const {
    matchCenterScorcard,
    thumbUrl,
    refreshMatchCardUrl,
    liveBlogUrl,
    predictorUrl,
  } =
    props.sectionItem || {};
  const { h1 } = props.seoData;
  let status = matchCenterScorcard?.matchCardData?.status;
  let liveMatchData = matchCenterScorcard?.matchCardData?.liveMatchData
    ? matchCenterScorcard.matchCardData.liveMatchData
    : '';
  // const { matchSeoData } = matchCenterScorcard;
  const matchCardData = matchCenterScorcard?.matchCardData || {};
  let isLiveMatch =
    (status && status.toLowerCase() === 'play in progress') ||
    (status && status.toLowerCase() === 'innings break') ||
    (status && status.toLowerCase() === 'drinks');
  isLiveMatch = isLiveMatch || true;
  const isUpcomingMatch =
    (status && status.toLowerCase() === 'match yet to begin') ||
    (status && status.toLowerCase() === 'match begins at');
  if (isUpcomingMatch) {
    groupData = groupData.filter(item => item && !item.donotShowUpcoming);
  }
  if (isUpcomingMatch || (status && status.toLowerCase() === 'match ended')) {
    isLiveMatch = false;
  }
  if (
    matchCenterScorcard &&
    matchCenterScorcard.matchArticleData &&
    Array.isArray(matchCenterScorcard.matchArticleData) &&
    matchCenterScorcard.matchArticleData[0] &&
    matchCenterScorcard.matchArticleData[0].items === ''
  ) {
    groupData = groupData.filter(
      item => item && item.link !== 'matchArticleData',
    );
  }
  if (matchCenterScorcard && !matchCenterScorcard.matchLiveBlogData) {
    groupData = groupData.filter(
      item => item && item.link !== 'matchLiveBlogData',
    );
  }
  const [liveMatchCardData, setLiveMatchCardData] = useState(liveMatchData);
  const [MatchScoreCardData, setmatchScorecardData] = useState(
    matchCenterScorcard?.matchScoreCardData || '',
  );
  const [MatchLiveblogData, setliveblogData] = useState(
    matchCenterScorcard?.matchLiveBlogData || '',
  );
  const [thumbslist, SetThumbslist] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let matchcardtimer;
  const deviceType = props?.deviceType;

  let {
    teamaid = '',
    teambid = '',
    Number = '',
    //event_name = '',
    teams = [],
    Time = '',
    start_date = '',
    // End_date = '',
    venue = {},
    predictorData = [],
    equation = {},
    innings = [],
    livescoreCardUrl = '',
    Coverage_level_id = '',
    isTestMatch = false,
    winningteam = '',
  } = {};
  let teamascore;
  let teambscore;
  let teamatestscore;
  let teambtestscore;
  const updateMatchCardData = () => {
    teamaid = matchCardData?.teamaid;
    teambid = matchCardData?.teambid;
    Number = matchCardData?.Number;
    teams = matchCardData?.teams;
    Time = matchCardData?.Time;
    start_date = matchCardData?.start_date;
    venue = matchCardData?.venue;
    status = matchCardData?.status;
    predictorData = matchCardData?.predictorData;
    equation = matchCardData?.equation;
    innings = matchCardData?.innings;
    livescoreCardUrl = matchCardData?.livescoreCardUrl;
    Coverage_level_id = matchCardData?.Coverage_level_id;
    isTestMatch = matchCardData?.isTestMatch;
    winningteam = matchCardData?.winningteam;
    teamascore =
      !isTestMatch && innings && innings.length > 0
        ? innings.filter(value => {
            if (value && value.Battingteam === teamaid) {
              return value;
            }
            return null;
          })
        : [];
    teamatestscore =
      isTestMatch && teams && Array.isArray(teams) && teams.length > 0
        ? teams[0].teamainngarr
        : [];
    teambscore =
      !isTestMatch && innings && innings.length > 0
        ? innings.filter(value => {
            if (value && value.Battingteam === teambid) {
              return value;
            }
            return null;
          })
        : [];
    teambtestscore =
      isTestMatch && teams && Array.isArray(teams) && teams.length > 1
        ? teams[1].teambinngarr
        : [];
    if (livescoreCardUrl && typeof livescoreCardUrl === 'string') {
      groupData.push({
        link: 'liveblog',
        name: 'liveblog',
      });
    }
  };
  updateMatchCardData();
  const fetchcommentryData = async () => {
    if (liveBlogUrl) {
      // if (matchCenterScorcard?.matchLiveBlogData) {
      //   setMatchCenterData(matchCenterScorcard.matchLiveBlogData);
      // }
      try {
        let items;
        let result;
        let inningsCnt = 0;
        if (innings && innings.length > 0) {
          innings.forEach(inng => {
            if (inng && inng.Total && inng.Total !== '') {
              inningsCnt += 1;
            }
          });
          while (inningsCnt > 0) {
            const url = `${liveBlogUrl}${inningsCnt}.json`;
            // eslint-disable-next-line no-await-in-loop
            const commentaryData = await makeRequest.get(
              url,
              {},
              'skipfeedengine',
            );
            if (commentaryData?.data?.Commentary) {
              if (!items) {
                items = [];
              }
              items = items.concat(commentaryData.data.Commentary);
            }
            inningsCnt -= 1;
          }
          result = processCommentaryData(items);
          if (result && Array.isArray(result) && result.length > 0) {
            // setMatchCenterData(result);
            matchCenterScorcard.matchLiveBlogData = result;
            setliveblogData(result);
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        // console.log(error);
      }
    }
  };
  const fetchScoreCardData = data => {
    if (data) {
      const teama = _get(data, `Teams[${teamaid}]`, '');
      teama.name = _get(data, `Teams[${teamaid}].Name_Short`, '');
      const teamb = _get(data, `Teams[${teambid}]`, '');
      teamb.name = _get(data, `Teams[${teambid}].Name_Short`, '');
      const tosswiningTeamId = _get(data, 'Matchdetail.Tosswonby', '');
      teams = [];
      teams.push(teama);
      teams.push(teamb);
      let matchinnings = _get(data, 'Innings', '');
      matchinnings = matchinnings.map((inng, index) => {
        if (inng) {
          const battingTeamId = _get(inng, 'Battingteam', '');
          const bowlingTeamId = _get(inng, 'Bowlingteam', '');
          const batteam = _get(data, `Teams[${battingTeamId}]`, '');
          const bowlteam = _get(data, `Teams[${bowlingTeamId}]`, '');
          const number = index + 1;
          const byes = _get(inng, 'Byes', '0');
          const legbyes = _get(inng, 'Legbyes', '0');
          const totalWides = _get(inng, 'Wides', '0');
          const totalNoballs = _get(inng, 'Noballs', '0');
          const penalty = _get(inng, 'Penalty', '0');
          const extraDetailsStr = ''
            .concat(parseInt(totalWides, 10) > 0 ? `W - ${totalWides}` : '')
            .concat(
              parseInt(totalNoballs, 10) > 0 && parseInt(totalWides, 10) > 0
                ? `,`
                : '',
            )
            .concat(
              parseInt(totalNoballs, 10) > 0 ? `NB - ${totalNoballs}` : '',
            )
            .concat(
              parseInt(totalNoballs, 10) > 0 && parseInt(legbyes, 10) > 0
                ? `,`
                : '',
            )
            .concat(parseInt(legbyes, 10) > 0 ? `LB - ${legbyes}` : '')
            .concat(
              parseInt(legbyes, 10) > 0 && parseInt(byes, 10) > 0 ? `,` : '',
            )
            .concat(parseInt(byes, 10) > 0 ? `B - ${byes}` : '')
            .concat(
              parseInt(byes, 10) > 0 && parseInt(penalty, 10) > 0 ? `,` : '',
            )
            .concat(parseInt(penalty, 10) > 0 ? `P - ${penalty}` : '');
          const extrasdetails = extraDetailsStr !== '' ? extraDetailsStr : '';
          const fows = processFallOfWickets(
            _get(inng, 'FallofWickets', ''),
            batteam,
          );
          return {
            battingTeamId,
            bowlingTeamId,
            battingTeam: _get(data, `Teams[${battingTeamId}].Name_Full`, ''),
            battingTeamSName: _get(
              data,
              `Teams[${battingTeamId}].Name_Short`,
              '',
            ),
            bowlingTeam: _get(data, `Teams[${bowlingTeamId}].Name_Full`, ''),
            number,
            batsmen: processBatsMan(_get(inng, 'Batsmen', ''), batteam),
            bowlers: processBowler(_get(inng, 'Bowlers', ''), bowlteam),
            fows,
            equation: {
              total: _get(inng, 'Total', ''),
              wickets: _get(inng, 'Wickets', ''),
              overs: _get(inng, 'Overs', ''),
              runRate: _get(inng, 'Runrate', ''),
            },
            extras: {
              byes,
              legbyes,
              totalWides,
              totalNoballs,
              penalty,
              total:
                parseInt(byes, 10) +
                parseInt(legbyes, 10) +
                parseInt(totalWides, 10) +
                parseInt(totalNoballs, 10) +
                parseInt(penalty, 10),
              details: extrasdetails,
            },
          };
        }
        return null;
      });
      const scoreCardData = {
        event: _get(data, 'Series.Name', ''),
        matchType: _get(data, 'Matchdetail.Match.Type', ''),
        matchNo: _get(data, 'Matchdetail.Match.Number', ''),
        matchDate: _get(data, 'Matchdetail.Match.Date', ''),
        matchStatus: _get(data, 'Matchdetail.Status', ''),
        venue: _get(data, 'Matchdetail.Venue.Name', ''),
        umpires: _get(data, 'Matchdetail.Officials.Umpires', ''),
        referee: _get(data, 'Matchdetail.Officials.Referee', ''),
        tosswonby: _get(data, `Teams[${tosswiningTeamId}].Name_Full`, ''),
        lastUpdatedDate: _get(data, 'Matchdetail.LastUpdateddate', ''),
        lastUpdatedTime: _get(data, 'Matchdetail.lastUpdatedTime', ''),
        equationText: _get(data, 'Matchdetail.Equation', ''),
        result: _get(data, 'Matchdetail.Result', ''),
        currentInning: _get(data, 'Matchdetail.currentInning', ''),
        manOfTheMatch: _get(data, 'Matchdetail.Awards.Player_Name', ''),
        teams,
        innings: matchinnings,
      };
      const dataArr = [];

      dataArr.push(scoreCardData);
      // setMatchCenterData(dataArr);
      matchCenterScorcard.matchScoreCardData = dataArr;
      setmatchScorecardData(dataArr);
      setIsLoading(false);
    }
  };
  const refreshPredictorData = () => {
    let predictorRefreshData = [];
    return new Promise(resolve => {
      try {
        if (predictorUrl) {
          makeRequest
            .get(predictorUrl, { isMobile: props.isWapView }, 'skipfeedengine')
            // eslint-disable-next-line consistent-return
            .then(result => {
              if (result?.data) {
                const { data } = result;
                if (data?.predictor) {
                  predictorRefreshData = processPredictorData(
                    data?.predictor,
                    teamaid,
                  );
                  resolve(predictorRefreshData);
                }
              }
            })
            .catch(() => {
              // console.log(error);
              resolve([]);
            });
        }
      } catch (e) {
        resolve(predictorRefreshData);
      }
    });
  };
  const fetchMatchCardData = async () => {
    if (refreshMatchCardUrl) {
      // const timeStamp = new Date().getTime();
      const url = `${refreshMatchCardUrl}`;
      let refreshpredictData;
      if (Coverage_level_id === '8') {
        refreshpredictData = await refreshPredictorData();
      }
      makeRequest
        .get(url, { isMobile: props.isWapView }, 'skipfeedengine')
        .then(result => {
          if (result?.data) {
            const { data } = result;
            if (data) {
              predictorData =
                Coverage_level_id === '8' ? refreshpredictData : '';
              const liveinnings = _get(data, 'Innings', '');
              if (
                liveinnings &&
                Array.isArray(liveinnings) &&
                liveinnings.length > 0
              ) {
                teams = matchCardData?.teams;
                const teamainnings = {
                  score: [],
                };
                const teambainnings = {
                  score: [],
                };
                liveinnings.forEach(inngs => {
                  if (inngs?.Battingteam === teamaid) {
                    teamainnings.battingteamName = teams[0]?.short_name;
                    teambainnings.battingteamName = teams[1]?.short_name;
                    teamainnings.score.push(
                      `${inngs?.Total}/${inngs?.Wickets}`,
                    );
                  } else {
                    teambainnings.battingteamName = teams[1]?.short_name;
                    teamainnings.battingteamName = teams[0]?.short_name;
                    teambainnings.score.push(
                      `${inngs?.Total}/${inngs?.Wickets}`,
                    );
                  }
                });
                const finalLength = liveinnings.length - 1;
                let currPartnerShip =
                  liveinnings[finalLength]?.Partnership_Current?.Batsmen;
                const battingTeamId = liveinnings[finalLength]?.Battingteam;
                const bowlingTeamId = liveinnings[finalLength]?.Bowlingteam;
                const teamsData = _get(data, 'Teams', undefined);
                const batsmanArr = liveinnings[finalLength]?.Batsmen;
                if (
                  currPartnerShip &&
                  Array.isArray(currPartnerShip) &&
                  currPartnerShip.length > 0
                ) {
                  currPartnerShip = currPartnerShip.map(bats => {
                    if (
                      batsmanArr &&
                      Array.isArray(batsmanArr) &&
                      batsmanArr.length > 0
                    ) {
                      // eslint-disable-next-line consistent-return
                      batsmanArr.forEach(batsMan => {
                        const batsManId = batsMan?.Batsman;
                        if (batsManId === bats?.Batsman) {
                          bats.Runs = batsMan?.Runs;
                          bats.Balls = batsMan?.Balls;
                          bats.Fours = batsMan?.Fours;
                          bats.Sixes = batsMan?.Sixes;
                          bats.Strikerate = batsMan?.Strikerate;
                          bats.Name =
                            teamsData[battingTeamId]?.Players[
                              batsManId
                            ]?.Name_Full;
                          bats.Link = `/topic/${teamsData[
                            battingTeamId
                          ]?.Players[
                            batsManId
                          ]?.Name_Full.toLowerCase().replace(/[ ]/g, '-')}`;
                          return bats;
                        }
                      });
                    }
                    return bats;
                  });
                  let currentBowler;
                  const BowlersArr = liveinnings[finalLength]?.Bowlers;
                  if (
                    BowlersArr &&
                    Array.isArray(BowlersArr) &&
                    BowlersArr.length > 0
                  ) {
                    currentBowler = BowlersArr.filter(bowler => {
                      const bowlerId = bowler?.Bowler;
                      if (bowler?.Isbowlingnow) {
                        bowler.Name =
                          teamsData[bowlingTeamId]?.Players[
                            bowlerId
                          ]?.Name_Full;
                        bowler.Link = `/topic/${teamsData[
                          bowlingTeamId
                        ]?.Players[bowlerId]?.Name_Full.toLowerCase().replace(
                          /[ ]/g,
                          '-',
                        )}`;
                        return bowler;
                      }
                      return null;
                    });
                  }
                  liveMatchData = {
                    status: _get(data, 'Matchdetail.Status', ''),
                    equation: _get(data, 'Matchequation.Equation', ''),
                    currentBattingTeam:
                      innings[finalLength]?.Battingteam === teamaid
                        ? teams[0]?.short_name
                        : teams[1]?.short_name,
                    score: `${liveinnings[finalLength]?.Total}/${
                      liveinnings[finalLength]?.Wickets
                    } (${liveinnings[finalLength]?.Overs} ${
                      liveinnings[finalLength]?.AllottedOvers
                        ? `/${liveinnings[finalLength]?.AllottedOvers}`
                        : ''
                    })`,
                    currRate: liveinnings[finalLength]?.Runrate,
                    currPartnerShip,
                    teamainnings,
                    teambainnings,
                    currentBowler,
                  };
                }
                setLiveMatchCardData(liveMatchData);
              }
              fetchScoreCardData(data);
              setIsLoading(false);
            }
          } else {
            setIsLoading(false);
          }
        });
    }
  };
  useEffect(() => {
    const url = thumbUrl;
    makeRequest
      .get(url, { isMobile: props.isWapView }, 'skipfeedengine')
      .then(result => {
        if (result?.data) {
          SetThumbslist(result?.data?.playerthumbs?.data);
        }
      });
  }, []);
  useEffect(() => {
    if (isLiveMatch) {
      setIsLoading(true);
      fetchMatchCardData();
      fetchcommentryData();
      if (matchcardtimer) {
        clearInterval(matchcardtimer);
      }
      matchcardtimer = setInterval(() => {
        setIsLoading(true);
        fetchMatchCardData();
        fetchcommentryData();
      }, 30000);
    }
    return () => clearInterval(matchcardtimer);
  }, []);
  const onGroupTabsChange = dataObj => {
    if (dataObj && dataObj?.link && dataObj?.name) {
      // setActiveGroupTab(dataObj?.name);
      if (dataObj?.link === 'liveblog' && dataObj?.link === 'liveblog') {
        window.location.href = livescoreCardUrl;
      }
      if (dataObj && dataObj.id) {
        const containerEle = document.getElementById(dataObj.id);
        if (
          containerEle &&
          containerEle !== null &&
          typeof window === 'object'
        ) {
          const headerOffset = 60;
          const elementPosition = containerEle.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    }
  };
  const loadCricketScoreCardData = () => false;

  /*** Top Card Data  */

  // eslint-disable-next-line camelcase
  const DateArr = start_date ? start_date.split('/') : ['', '', ''];
  const MatchDate = `${DateArr[0]}-${DateArr[1]}-${DateArr[2]}`;

  const liveMatchCardClass = isLiveMatch ? `${s.liveMatchCard}` : '';
  const testMatchCardClass = isTestMatch ? `${s.testMatchCard}` : '';
  const closedMatchCardClass =
    status === 'Match Ended' ? `${s.endedMatchCard}` : '';
  const minutes = Math.round((Time - Math.floor(Time, 10)) * 100);
  // console.log('DEFULT_SELECT', DEFULT_SELECT);
  /**** End Here ********/
  return (
    <>
      <div className={s.matchCardWrap}>
        <h1 className={s.h1tag}>{h1}</h1>
        {isLoading && <LoaderSpinner />}
        {!liveMatchCardData && (
          <div
            className={`${
              s.matchCard
            } ${liveMatchCardClass} ${closedMatchCardClass} ${testMatchCardClass} `}
          >
            <div className={s.teamInfo}>
              <div className={s.left}>
                {teams &&
                  teams[0] && (
                    <>
                      <strong>{teams[0].short_name}</strong>
                      <div className={s.flag_score}>
                        <div className={s.flag}>
                          <div className={s.iconWrap}>
                            <i
                              className={`${s[teams[0].short_name]} ${
                                s.flagIcon
                              }`}
                            />
                            {status === 'Match Ended' &&
                              winningteam === teamaid && (
                                <i className={s.winningteam} />
                              )}
                          </div>
                          {!isTestMatch &&
                            teamascore &&
                            Array.isArray(teamascore) &&
                            teamascore.length > 0 &&
                            teamascore[0] && (
                              <>
                                <div className={s.scoreValue}>
                                  <div className={s.score}>
                                    {teamascore[0].Total &&
                                      teamascore[0].Total !== '0' && (
                                        <span className={s.run}>
                                          {teamascore[0].Total}/{
                                            teamascore[0].Wickets
                                          }
                                        </span>
                                      )}
                                    {teams[0]?.battingteam && (
                                      <i className={s.battingteam} />
                                    )}
                                  </div>
                                  <span className={s.over}>
                                    {teamascore[0].Overs}
                                    {teamascore[0].Overs && ' ovs'}
                                  </span>
                                </div>
                              </>
                            )}

                          {isTestMatch &&
                            teamatestscore &&
                            Array.isArray(teamatestscore) &&
                            teamatestscore.length > 0 && (
                              <div className={s.scoreValueTest}>
                                {teamatestscore.map((inngs, index) => (
                                  <>
                                    <span>{inningsMappings[index]} Inngs</span>
                                    <strong>
                                      {inngs}
                                      {teams[0]?.battingteam &&
                                        index === 0 && (
                                          <i className={s.battingteam} />
                                        )}
                                    </strong>
                                  </>
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}
              </div>
              {}
              <div className={s.mid}>
                <span className={s.odi}>{Number}</span>
                {!isLiveMatch && (
                  <>
                    <strong className={s.time}>
                      {format(
                        new Date(
                          DateArr[2],
                          DateArr[1],
                          DateArr[0],
                          parseInt(Time, 10),
                          minutes,
                        ),
                        'hh:mmaa',
                      )}
                    </strong>
                    <span className={s.date}>
                      {format(Date.parse(MatchDate), 'D MMM, YYYY')}
                    </span>
                  </>
                )}
                {isLiveMatch &&
                  status !== 'Match Ended' && (
                    <div className={s.lbBlinker}>
                      <div className={`${s.liveBtn}`} />
                      <span>live</span>
                    </div>
                  )}
                {status === 'Match Ended' && <i className={s.vsIcon} />}
              </div>
              <div className={s.right}>
                {teams &&
                  teams[1] && (
                    <>
                      <strong>{teams[1].short_name}</strong>
                      <div className={s.flag_score}>
                        <div className={s.flag}>
                          <div className={s.iconWrap}>
                            <i
                              className={`${s[teams[1].short_name]} ${
                                s.flagIcon
                              }`}
                            />
                            {status === 'Match Ended' &&
                              winningteam === teambid && (
                                <i className={s.winningteam} />
                              )}
                          </div>
                          {!isTestMatch &&
                            teambscore &&
                            Array.isArray(teambscore) &&
                            teambscore.length > 0 &&
                            teambscore[0] && (
                              <>
                                <div className={s.scoreValue}>
                                  <div className={s.score}>
                                    {teams[1]?.battingteam && (
                                      <i className={s.battingteam} />
                                    )}
                                    {teambscore[0].Total &&
                                      teambscore[0].Total !== '0' && (
                                        <span className={s.run}>
                                          {teambscore[0].Total}/{
                                            teambscore[0].Wickets
                                          }
                                        </span>
                                      )}
                                  </div>
                                  <span className={s.over}>
                                    {teambscore[0].Overs}
                                    {teambscore[0].Overs && ' ovs'}
                                  </span>
                                </div>
                              </>
                            )}
                          {isTestMatch &&
                            teambtestscore &&
                            Array.isArray(teambtestscore) &&
                            teambtestscore.length > 0 && (
                              <div className={s.scoreValueTest}>
                                {teambtestscore.map((inngs, index) => (
                                  <>
                                    <span>{inningsMappings[index]} Inngs</span>
                                    <strong>
                                      {teams[1]?.battingteam &&
                                        index === 0 && (
                                          <i className={s.battingteam} />
                                        )}
                                      {inngs}
                                    </strong>
                                  </>
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
            {/* {!isLiveMatch && (
            <div
              className={s.remind}
              onClick={e =>
                ical_download(
                  start_date,
                  End_date,
                  `${event_name} ${Array.isArray(teams) && teams.length>0 ? teams[0].short_name:''} vs ${Array.isArray(teams) && teams.length>0 ?
                    teams[1].short_name : ''
                  }`,
                  status,
                  venue.name,
                  e,
                )
              }
            >
              <strong>Remind me </strong> <i className={s.bell} />
            </div>
          )} */}
            {(isLiveMatch || status === 'Match Ended') && (
              <div className={s.stadiumInfo}>
                {equation &&
                  equation.Equation && <span>{equation.Equation}</span>}
                <a
                  // eslint-disable-next-line no-script-url
                  href="javascript:void(0);"
                  onClick={event => {
                    event.preventDefault();
                    onGroupTabsChange({
                      name: 'Scorecard',
                      link: 'matchScoreCardData',
                      id: 'matchScoreCardDataContainer',
                    });
                  }}
                  className={s.venueLink}
                >
                  View Scorecard
                </a>
              </div>
            )}
            {!isLiveMatch &&
              status !== 'Match Ended' && (
                <div className={s.stadiumInfo}>
                  <span>{venue.name}</span>
                  <a
                    href={venue.link}
                    className={s.venueLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Venue Details
                  </a>
                </div>
              )}
          </div>
        )}
        {liveMatchCardData !== '' && (
          <MatchCenterLiveCard
            liveMatchCardData={liveMatchCardData}
            key={liveMatchCardData?.score}
          />
        )}
        {status !== 'Match Ended' &&
          predictorData &&
          predictorData.length > 0 &&
          predictorData[0].win_perc &&
          predictorData[0].win_perc !== '-' && (
            <div className={s.predictor}>
              <div className={`${s.favourite}`}>
                <div className={s.left}>
                  {Array.isArray(teams) &&
                    teams.length > 0 && (
                      <div className={s.flag}>
                        <i
                          className={`${s.icon} ${
                            s[
                              teams && Array.isArray(teams) && teams.length > 0
                                ? teams[0]?.short_name
                                : ''
                            ]
                          }`}
                        />
                      </div>
                    )}
                  <strong>
                    {teams[0]?.short_name} {predictorData[0].win_perc}%{' '}
                    <span className={s.web}>(Winning Probability)</span>
                  </strong>
                </div>
                <div className={s.right}>
                  <strong>
                    {teams[1]?.short_name} {predictorData[1].win_perc}%
                  </strong>
                  {Array.isArray(teams) &&
                    teams.length > 1 && (
                      <div className={s.flag}>
                        <i
                          className={`${s.icon} ${
                            s[
                              teams && Array.isArray(teams) && teams.length > 0
                                ? teams[1]?.short_name
                                : ''
                            ]
                          }`}
                        />
                      </div>
                    )}
                </div>
              </div>

              <div className={s.percentagebar}>
                <div
                  className={s.percentagebarfill}
                  style={{ width: `${predictorData[0].win_perc}%` }}
                />
                <div
                  className={s.percentagebarunfill}
                  style={{ width: `${predictorData[1].win_perc}%` }}
                />
              </div>
              <div className={s.wap}>(Winning Probability)</div>
              {/* <div className={s.match_status_color}>
                <span className={s.win}> Win</span>
                <span className={s.draw}> draw</span>
                <span className={s.lose}> lose</span>
              </div> */}
            </div>
          )}
        {groupData &&
          Array.isArray(groupData) &&
          groupData.length > 0 && (
            <div className="matchCentertab">
              <CricketRanking
                groupData={groupData}
                onGroupTabsChange={onGroupTabsChange}
                cricketRanking=""
                currentTab={isUpcomingMatch ? 'Match Details' : 'Scorecard'}
                hideTabs=""
              />
            </div>
          )}
        <div className={s.matchCenterAllData}>
          {!isUpcomingMatch &&
            MatchScoreCardData &&
            Array.isArray(MatchScoreCardData) &&
            MatchScoreCardData.length > 0 && (
              <div className="slick_UI" id="matchScoreCardDataContainer">
                <div className={s.heading}>
                  <h3>Match Scorecard</h3>
                </div>
                <CricketScorecardV2
                  loadDataFn={loadCricketScoreCardData}
                  data={MatchScoreCardData[0]}
                  noShowBallByBall
                  params={{ isWapView: props.isWapView }}
                  wrapperClass=""
                />
              </div>
            )}
          {matchCenterScorcard &&
            matchCenterScorcard.matchDetailsData &&
            Array.isArray(matchCenterScorcard.matchDetailsData) &&
            matchCenterScorcard.matchDetailsData.length > 0 && (
              <div
                className={`${s.matchCenterDetails} matchCenterDetails`}
                id="matchDetailsDataContainer"
              >
                <div className={s.heading}>
                  <h3>Match Details</h3>
                </div>
                <StatList items={matchCenterScorcard.matchDetailsData[0]} />
              </div>
            )}
          {matchCenterScorcard &&
            matchCenterScorcard.matchStatsData &&
            Array.isArray(matchCenterScorcard.matchStatsData) &&
            matchCenterScorcard.matchStatsData.length > 0 && (
              <div id="matchStatsDataContainer" className={s.teamsMatchUp}>
                <div className={s.heading}>
                  <h3>Teams Match Up</h3>
                </div>
                <MatchStatsList
                  matchStatsData={{
                    ...matchCenterScorcard.matchStatsData[0],
                    ...matchCenterScorcard.matchStatsData[1],
                  }}
                  teamaid={teamaid}
                  teambid={teambid}
                  teamashrt_name={
                    teams[0]?.short_name
                      ? teams[0]?.short_name.toLowerCase()
                      : ''
                  }
                  teambshrt_name={
                    teams[1]?.short_name
                      ? teams[1]?.short_name.toLowerCase()
                      : ''
                  }
                  teamaname={teams[0]?.name}
                  teambname={teams[1]?.name}
                  thumbUrl={thumbUrl}
                  thumbslist={thumbslist}
                />
              </div>
            )}
          {matchCenterScorcard &&
            matchCenterScorcard.matchSquadData &&
            Array.isArray(matchCenterScorcard.matchSquadData) &&
            matchCenterScorcard.matchSquadData.length > 0 && (
              <div className={s.squadWrap} id="matchSquadDataContainer">
                <div className={s.heading}>
                  <h3>Match Squad</h3>
                </div>
                <MatchSquadList
                  matchSquadData={matchCenterScorcard.matchSquadData}
                  teamaid={teamaid}
                  teambid={teambid}
                  teamashrt_name={
                    teams[0]?.short_name
                      ? teams[0]?.short_name.toLowerCase()
                      : ''
                  }
                  teambshrt_name={
                    teams[1]?.short_name
                      ? teams[1]?.short_name.toLowerCase()
                      : ''
                  }
                  teamaname={teams[0]?.name}
                  teambname={teams[1]?.name}
                  deviceType={deviceType}
                  thumbUrl={thumbUrl}
                  thumbslist={thumbslist}
                />
              </div>
            )}
          {matchCenterScorcard &&
            matchCenterScorcard.matchArticleData &&
            Array.isArray(matchCenterScorcard.matchArticleData) &&
            matchCenterScorcard.matchArticleData.length > 0 &&
            matchCenterScorcard.matchArticleData[0].items !== '' && (
              <div
                className={`${s.matchCenterArticles} matchCenterArticles`}
                id="matchArticleDataContainer"
              >
                <div className={s.heading}>
                  <h3>Match News</h3>
                </div>
                <CoverLayout
                  sectionData={matchCenterScorcard.matchArticleData[0]}
                  moreLink=""
                  leadImageUpperLimit="-1"
                  sportsImagewidth
                />
              </div>
            )}
          {MatchLiveblogData !== '' && (
            <div id="matchLiveBlogDataContainer">
              <div className={s.heading}>
                <h3>Commentary</h3>
              </div>
              <Timeline
                updatedContents={MatchLiveblogData}
                utm="&source=share&medium=####&campaign=liveblog_new_mweb"
                specialClass="matchCenterOverSummary"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
MatchCenterCard.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  deviceType: PropTypes.string,
  isWapView: PropTypes.bool,
  seoData: PropTypes.objectOf({}),
};
MatchCenterCard.defaultProps = {
  sectionItem: {},
  deviceType: '',
  isWapView: false,
  seoData: {},
};

export default MatchCenterCard;
